export default "__VITE_ASSET__fa6673ee__"